import { navigate } from "../utilities/CustomRoute/Navigate";
import { LeftIcon, RightIcon } from "./atoms/Icons";
import { CardGames } from "./atoms/GameCard";
import { Game } from "../interfaces/game.interface";
import { useDraggable } from "react-use-draggable-scroll";
import { useRef } from "react";

type Props = {
  title: string;
  games: Game[];
  navigateSort: keyof Game;
  setSelectedGame?: any;
  setShowFeedback?: any;
};

export const GamesCarousel = (props: Props) => {
  const ref =
    useRef<HTMLDivElement>() as React.MutableRefObject<HTMLDivElement>;
  const { events } = useDraggable(ref);

  // Make a fake ref to avoid error
  if (props.games.length === 0) return <div ref={ref} />;

  const scrollLeft = () => {
    if (!ref.current) return;

    if (ref.current.scrollLeft < 10) {
      // Jump to the end
      ref.current.scrollTo({
        left: ref.current.scrollWidth - ref.current.offsetWidth,
        behavior: "smooth",
      });
    } else {
      ref.current.scrollBy({
        left: -ref.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (!ref.current) return;

    // If at the end, jump to the start
    const scrollRight =
      ref.current.scrollWidth -
      ref.current.scrollLeft -
      ref.current.offsetWidth;

    if (scrollRight < 10) {
      ref.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    } else {
      ref.current.scrollBy({
        left: ref.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-8">
      <div className="container">
        <div className="flex items-center gap-2 mb-6">
          <h4
            className="font-bold text-[20px] text-white cursor-pointer"
            onClick={() => navigate("games", { sort: props.navigateSort })}
          >
            {props.title}
          </h4>
          <RightIcon />
        </div>

        <div className="flex items-center">
          <div className="flex-shrink cursor-pointer" onClick={scrollLeft}>
            <LeftIcon width={40} height={100} />
          </div>
          <div
            className="flex-grow flex overflow-x-scroll scrolStyle py-2"
            ref={ref}
            {...events}
          >
            {props.games.map((game, id) => {
              return (
                <div className="w-1/4 px-2 flex-grow-0 flex-shrink-0 carousel-game">
                  <CardGames
                    key={id}
                    game={game}
                    setSelectedGame={props.setSelectedGame}
                    setShowFeedback={props.setShowFeedback}
                  />
                </div>
              );
            })}
          </div>
          <div className="flex-shrink cursor-pointer" onClick={scrollRight}>
            <RightIcon width={40} height={100} />
          </div>
        </div>
      </div>
    </section>
  );
};
